<template>
  <div>
    <van-dialog
      v-model="show"
      show-cancel-button
      confirmButtonText="确认支付"
      cancelButtonText="取消支付"
      cancelButtonColor="#1989fa"
      @confirm="confirm"
      :before-close="beforeClose"
    >
      <div slot="title">
        <span style="color:#1989fa ;">选择支付方式</span>
      </div>
      <div slot="default" v-if="spitem != null">
        <div class="d-content">
          <div class="d-title">
            本次共需支付
            <span class="d-price">￥{{spitem.pay_price}}</span>
          </div>
          <van-radio-group v-model="selectModel" class="rg" style="width: 80%;">
            <van-radio v-for="(item,index) in list" :name="index" :key="index">{{item.title}}</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="close">
        <div class="ec" @click="onClose">
          <van-icon name="clear" size="30" color="#8f8f8f"/>
        </div>
      </div>
    </van-dialog>

    <van-popup
      v-for="(item,i) in hbimg"
      :key="'popup'+i"
      :overlay="i==0"
      v-model="item.show"
      class="gg-popup"
      @close="ggClose1(i)"
      :close-on-click-overlay="false"
    >
      <div class="cc-qq">
        <div class="title" v-if="item.title">
          <p>{{item.title}}</p>
        </div>
        <div class="gg-content">
            <!-- <img class="img" :src="item.image"> -->
          <van-image height="510" width="320" :src="item.image"/>
        </div>
      </div>
      <div class="qq-clode">
        <van-icon name="close" @click="ggClose1(i)"/>
      </div>
    </van-popup>
    <!-- <van-dialog v-model="hbshow">
      <van-swipe class="dioconten" :autoplay="2000" style="height: 250px;">
        <van-swipe-item v-for="(image, index) in hbimg" :key="index">
          <img class="img" v-lazy="image">
        </van-swipe-item>
      </van-swipe> 
    </van-dialog>-->
  </div>
</template>

<script>
import * as util from "@/utils/network";
import { Toast } from "vant";
export default {
  data() {
    return {
      show: false,
      role: null,
      list: null,
      price: 0,
      selectModel: null,
      spitem: null,
      hbshow: false,
      hbimg: []
    };
  },
  methods: {
    confirm() {
      let that = this;
      if (that.selectModel == null) {
        Toast("请选择支付方式");
        return;
      }

      /*if (that.spitem.total_price == null) {
        Toast("支付金额异常");
        this.show = false;
        return;
      }*/
      //console.log("role", that.role);
      that.goZfun(that.spitem);
      that.show = false;
      //console.log("商品信息", that.spitem);
    },
    beforeClose(active, done) {
      //console.log(active);
      let that = this;
      if (active == "confirm") {
        done(false);
      } else {
        done();
      }
    },
    // 支付
    goZfun(item) {
      let that = this;
      var url = "/addons/litestore/api.order/order_pay";
      let param = {
        id: item.id,
        role: that.role,
        type: "gzh",
        payType: "scan",
        method: that.selectModel
      };
      /*console.log('role',that.role)
      return false;*/

      let istrue = true;
      //这里直接调用网络接口
      util.post(url, param, function(result) {
        if (result.code == 0) {
          Toast.fail(result.msg);
          return false;
        }

        if (result.code == 1008) {
          //这里不直接跳转了，提示框  为绑定微信，跳转到my页面 绑定微信
          that.$dialog
            .confirm({
              title: "未通过微信登录",
              message:
                "您的账号未绑定微信号，请跳转后绑定微信号再进入未支付订单继续支付。"
            })
            .then(() => {
              that.$router.push({
                path: "/My"
              });
            })
            .catch(() => {
              that.$router.push({
                name: "OrderMy",
                params: {
                  showType: "0"
                }
              });
            });
        } else {
          //这里发起支付
          console.log("这里能够符合支付条件");

          if (that.selectModel == "money" || result.code == 200) {
            //console.log(result)
            console.log("len", result.data.length);

            Toast.success(result.msg);
            if (result.data.length === 0) {

              var redirect_url = that.role == 10 ? 'myorder/list?showType=0' : 'disorder?showType=0';
              setTimeout(() => {
                util.redirect(redirect_url);
              }, 1200);
            } else {
              util.redirect(
                "hbPage?order_id=" + result.data.order_id + "&role=" + that.role
              );
            }
          } else {
            that.wx_pay_fun(result.data);
          }
        }
      });
      // if (istrue) {
      // 	Toast.success("支付成功")
      // 	this.$emit('onSx');
      // }
    },
    wx_pay_fun(re) {
      var vm = this;
      if (typeof WeixinJSBridge == "undefined") {
        //微信浏览器内置对象。参考微信官方文档
        setTimeout(() => {
          vm.$toast("请使用微信打开");
        }, 100);
        var linkName = vm.role == 20 ? "DisOrder" : "OrderMy";
        vm.$router.push({
          name: linkName,
          params: {
            showType: "0"
          }
        });
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            vm.onBridgeReady(re),
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", vm.onBridgeReady(re));
          document.attachEvent("onWeixinJSBridgeReady", vm.onBridgeReady(re));
        }
      } else {
        vm.onBridgeReady(re);
      }
    },
    onBridgeReady(data) {
      var vm = this;
      //alert(JSON.stringify(data))
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId,
          nonceStr: data.nonceStr,
          package: data.package,
          signType: data.signType,
          paySign: data.paySign,
          timeStamp: data.timeStamp
        },
        function(res) {
          console.log(res.err_msg);
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            vm.$toast("恭喜，支付成功");
          } else {
            vm.$toast("未支付或支付失败");
          }
          setTimeout(() => {
            location.reload();
          }, 1000);
        }
      );
    },

    refOnShow(item, type) {
      this.selectModel = null;
      this.spitem = item;
      console.log("商品信息", this.spitem);
      this.onShow(type);
    },
    async getHbData() {
      var url = "/addons/litestore/api.reward/getOfferActivity";
      let that = this;
      that.hbimg=[]
      var params = {
        order_id: that.spitem.id,
        role: that.role
      };
      //这里直接调用网络接口
      await util.post(url, params, function(result) {
        var data = result.data;
        if (result.data.length != 0) {
          var imgss = Object.values(data.guide_img);
          if (imgss.length > 0) {
            imgss.map(item => {
              that.hbimg.push({
                title: "天降红包",
                show: true,
                image: item
              });
            });
          }else{
            that.show = true;
          }
        }else{
            that.show = true;
          }
      });
    },
    ggClose1(i) {
      this.hbimg[i].show = false;
      console.log(i)
      if (i == 0) {
        this.show = true;
      }
    },
    onShow(type) {
      this.role = this.$route.query.role
        ? this.$route.query.role
        : type == 1
        ? 10
        : 20;
      this.getHbData();
      this.getData(type); 
      // if (this.hbimg.length == 0) {
      //   this.show = true;
      // }
    },
    onClose() {
      this.show = false;
    },
    // 获取数据
    async getData(type) {
      var url = "/addons/litestore/api.order/get_payMethod";
      let that = this;
      //这里直接调用网络接口
      await util.post(url, { type }, function(res) {
        that.list = res.data;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.van-overlay {

  background-color: var(--overlay-background-color,rgba(0,0,0,.7));

  height: 100%;

  left: 0;

  position: fixed;

  top: 0;

  width: 100%;

}


.van-dialog {
  overflow: inherit !important;
}

/deep/.van-dialog__footer {
  border-bottom-left-radius: 16px !important;
  border-bottom-right-radius: 16px !important;
}

/deep/.van-hairline--left {
  color: #fff;
  background-color: rgb(25, 137, 250);
}

.d-content {
  padding: 10px 0 20px 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  // border-bottom: #ececec .5px solid;

  .rg {
    .van-radio {
      padding: 10px 0;
      text-align: center;
      justify-content: center;
    }
  }
}

.d-title {
  text-align: center;
  line-height: 50px;
  color: #737373;

  .d-price {
    font-size: 20px;
  }
}

.close {
  position: absolute;
  top: -15px;
  right: -12px;

  .ec {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #fff;
  }
}
.gg-popup {
  background: transparent;

  .cc-qq {
    border-radius: 10px;
    background-color: #fff;

    .title {
      padding: 8px 10px;
      font-size: 14px;
      background-color: #ff8a3a;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      color: #fff;

      p {
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .van-row {
      padding: 0 15px;
      margin-top: 10px;

      .van-col--12 {
        .van-image {
          height: 156px;
        }
      }

      .van-col--8 {
        .van-image {
          height: 104px;
        }
      }
    }
    .gg-content {
      max-height: 520px;
      // height: 400px;
      // padding: 15px;
      overflow-x: hidden;
      // overflow-y: scroll;
      font-size: 13px;
      line-height: 22px;
    }
  }

  .qq-clode {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;

    .van-icon {
      color: #fff;
      font-size: 28px;
    }
  }
}

.dioconten {
  padding-top: 20px;
  text-align: center;
  // .tips {
  //   padding: 10px 0;
  //   color: red;
  // }
  .img {
    width: 100%;
    height: auto;
  }
}
</style>
